import { AgGridReact } from 'ag-grid-react';
import { isEmpty } from 'lodash';
import { Fragment, useContext, useMemo, useState } from 'react';
import { Row } from 'react-bootstrap';
import { numberOfItemsPerPage } from '../../../constants/globals';
import AuthContext from '../../../context/auth_context';
import { prepareForExport } from '../export/support';
import { mapperSettings, sideBar } from '../utils';
import AgGridFooter from './AgGridFooter';

const AgGridTable = (props) => {
  const {
      gridRef,
      t,
      gt,
      rowsList,
      columnSettingsList,
      onSelectionChange,
      onFilterModified,
      setAction,
      tableTitle,
      setSelectedRow,
      singleSelect,
      hideActionColumn = false,
      setRowsChecked,
    } = props || {},
    {
      CellRender,
      ActiveFilter: ActiveFilterTranslation,
      Labels,
      Footer,
    } = t || {};
  const { allowedActions } = useContext(AuthContext);

  const [pageSize, setPageSize] = useState(numberOfItemsPerPage);

  const defaultColDef = useMemo(
    () => ({
      floatingFilter: true,
      resizable: true,
      sortable: true,
      enableRowGroup: true,
    }),
    []
  );

  const columnDefs = useMemo(
    () =>
      !isEmpty(columnSettingsList)
        ? mapperSettings(
            columnSettingsList,
            {
              ActiveFilterTranslation,
              CellRender,
            },
            { setAction, allowedActions, hideActionColumn }
          )
        : [],
    [
      columnSettingsList,
      allowedActions,
      ActiveFilterTranslation,
      CellRender,
      setAction,
      hideActionColumn,
    ]
  );

  const onPageSizeChangeHandler = (event) => {
    setPageSize(event.target.value);
  };

  const selectRowHandler = (params) => {
    const selectedNodes = Object.values(
      params?.api?.selectionService?.selectedNodes
    )?.filter((node) => node);
    if (selectedNodes?.length > 0) {
      setSelectedRow(selectedNodes[0].data);
    } else {
      setSelectedRow(null); // Deselect by setting selectedRow to null
    }
  };

  const onFilterChangedHandler = (params) => {
    const selectedAndDisplayedNodes = Object.values(
      params?.api?.selectionService?.selectedNodes
    )?.filter((node) => node && node.selected && node.displayed);
    setRowsChecked(selectedAndDisplayedNodes);
  };

  return (
    <Fragment>
      <Row className="ag-theme-alpine container-wrapper pr-0">
        <AgGridReact
          ref={gridRef}
          localeText={{ ...Labels }}
          rowData={rowsList}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          animateRows={true}
          sideBar={sideBar}
          pivotPanelShow={'always'}
          pagination={true}
          rowGroupPanelShow={'always'}
          rowSelection={singleSelect ? 'single' : 'multiple'}
          paginationPageSize={pageSize}
          groupSelectsChildren={true}
          onSelectionChanged={onSelectionChange}
          onFilterModified={onFilterModified}
          rowHeight={30}
          headerHeight={30}
          groupHeaderHeight={30}
          floatingFiltersHeight={30}
          pivotHeaderHeight={30}
          pivotGroupHeaderHeight={30}
          defaultExcelExportParams={prepareForExport(gridRef, gt, tableTitle)}
          defaultCsvExportParams={prepareForExport(gridRef, gt, tableTitle)}
          onRowSelected={selectRowHandler}
          onFilterChanged={onFilterChangedHandler}
        />
      </Row>
      <Row className="d-flex justify-content-between align-items-start pr-none">
        <AgGridFooter
          onPageSizeChange={onPageSizeChangeHandler}
          t={Footer}
          pageSize={pageSize}
        />
      </Row>
    </Fragment>
  );
};

export default AgGridTable;
